export enum PhaseStructureTypeEnum {
  Drywall = 'Drywall',
  DrywallAndPaint = 'DrywallAndPaint',
}
